import { render } from "./WorkVideoModal.vue?vue&type=template&id=6e1efccd"
import script from "./WorkVideoModal.vue?vue&type=script&lang=js"
export * from "./WorkVideoModal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__